import { Helper } from '@/mixin/helper'

export default [
    {
        path: '/liveview/',
        name: 'Liveview',
        meta: {
            authRequired: true,
            hasAccess: true,
            beforeResolve(_, routeFrom, next) {
                Helper.methods.userLogging('Access', _)
                next()
            }
        },
        component: () =>
            import( /* webpackChunkName: "liveview" */ '@/router/views/liveview/index')
    },
]